<template>
  <div>
    <Banner />

    <admin-app-bar />

    <welcome />

    <video-container />

    <services />

    <about-me />
  </div>
</template>

<script>
export default {
  name: "CoreView",

  components: {
    Banner: () => import("@/components/Banner"),
    AdminAppBar: () => import("@/components/core/AdminAppBar"),
    Services: () => import("@/components/Services"),
    Welcome: () => import("@/components/Welcome"),
    AboutMe: () => import("@/components/AboutMe"),
    VideoContainer: () => import("@/components/VideoContainer"),
  },
};
</script>
